import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_LEGAL_ENTITIES);
var axios_instance_stepper_status = get_axios_instance(api_variables.SERVICE_ONBOARDING_STEPPER_STATUS);

const _pk_name = "id";

const state = {
    data: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    stepperStatus: [],
    record: {},
    editMode: false,
    nav_items_entity: [],
    nav_items: []
}

const getState = (stepper) => {
  return stepper ? "complete" : "pending";
}

const setNavItemsState = (stepperState, entity_index) => {
  let navItems = [{
      type: "section",
      header: "Company Info",
      items: [{
                type: "navitem",
                label: "Legal Entities Info",
                status: getState(stepperState.legal_entities_info),
                // prev_status: "pending",
                // code: 'legalEntity',
                path: getPathForStep(entity_index,'legal_entities','modifyLegalEntity')
            },
            {
              type: "navitem",
              label: "Locations",
              status: getState(stepperState.locations),
              // prev_status: "pending",
              // code: 'location',
              path: getPathForStep(entity_index, 'locations'),
              children: [{
                  path: getPathForStep(entity_index, 'locations', 'addlocation')
              }]
       }]
    },
    {
      type: "section",
      header: "Payroll",
      items: [
        {
          type: "navitem",
          label: "Statutory Settings",
          status: getState(stepperState.statutory_settings),
          // prev_status: "pending",
          // code: 'statutory',
          path: getPathForStep(entity_index, 'statutory')
        }, {
          type: "navitem",
          label: "Departments",
          status: getState(stepperState.departments),
          path: getPathForStep(entity_index, "departments")
        }, {
          type: "navitem",
          label: "Cost Centres",
          status: getState(stepperState.cost_centres),
          // prev_status: "pending",
          // code: 'costCentre',
          path: getPathForStep(entity_index, 'costcenters')
        },{
          type: "navitem",
          label: "Designations",
          status: getState(stepperState.designations),
          // prev_status: "pending",
          // code: 'designation',
          path: getPathForStep(entity_index, 'designation')
        },
        {
          type: "navitem",
          label: "Levels",
          status: getState(stepperState.levels),
          path:getPathForStep(entity_index, 'level')
        },
        {
          type: "navitem",
          label: "Salary Grades",
          status: getState(stepperState.salary_grades),
          // prev_status: "pending",
          // code: 'grade',
          path: getPathForStep(entity_index, 'grades'),
          children: [{
            path: getPathForStep(entity_index, 'grades', 'addgrades')
          }, {
            path: getPathForStep(entity_index, 'grades', 'adddesignations')
          }]
        },{
          type:"navitem",
          label: "Employee Categories",
          status: getState(stepperState.employee_categories),
          // prev_status: "pending",
          // code: 'category',
          path: getPathForStep(entity_index, 'empCategories'),
        }, {
          type: "navitem",
          label: "Salary Bands",
          status: getState(stepperState.salary_bands),
          // prev_status: "pending",
          // code: 'band',
          path: getPathForStep(entity_index, 'bands')
        },{
          type: "navitem",
          label: "Miscellaneous",
          status: getState(stepperState.miscellaneous),
          // prev_status: "pending",
          // code: 'misc',
          path: getPathForStep(entity_index, 'misc'),
          children: [{
            path: getPathForStep(entity_index, 'misc', 'addFbpBand')
          }]
        },
        {
          type: "navitem",
          label: "Payroll Preferences",
          status: getState(stepperState.payroll_preferences),
          // prev_status: "pending",
          // code: 'preferences',
          path: getPathForStep(entity_index, 'preferences'),
          children: [{
            path: getPathForStep(entity_index, 'preferences', 'modifyStructureDetails')
          }]
        },
        {
            type: "navitem",
            label: "Paygroups",
            status: getState(stepperState.paygroups),
            // prev_status: "pending",
            // code: 'paygroup',
            path: getPathForStep(entity_index, 'paygroup')
        },
        // {
        //   type: "navitem",
        //   label: "Payment Settings",
        //   status: getState(stepperState.paygroups),
        //   path: getPathForStep(entity_index, "hsbcPaymentSetting")
        // },
        
      ]
    },
    {
      type: "section",
      header: "Flexible Benefit Plans",
      items: [
        {
          type: "navitem",
          label: "FBP Settings",
          status: getState(stepperState.fbpConfigure),
          // prev_status: "pending",
          // code: 'fbpConfigure',
          path: getPathForStep(entity_index, 'fbpConfigure')
        },
        {
          type: "navitem",
          label: "FBP CTC Slab",
          status: getState(stepperState.ctcSlab),
          path: getPathForStep(entity_index, "ctcSlab")
        },
        // {
        //   type: "navitem",
        //   label: "FBP Component Grouping",
        //   status: getState(stepperState.ctcSlab),
        //   path: getPathForStep(entity_index, "fbpComponentGrouping")
        // },
        {
          type: "navitem",
          label: "FBP Eligibility",
          status: getState(stepperState.fbpEligibility),
          path: getPathForStep(entity_index, "fbpEligibility")
        },
      ]},
    {
      type: "section",
      header: "Others",
      items: [{
          type: "navitem",
          label: "Add Employee",
          status: getState(stepperState.add_employee),
          // prev_status: "pending",
          // code: 'employee',
          path: getPathForStep(entity_index, 'employeeDashboard'),
          // children: [{
          //   path: getPathForStep(entity_index, 'employees', 'edit')
          // }]
        },
        {
          type: "navitem",
          label: "Legacy Data",
          status: getState(stepperState.legacy_data),
          path: getPathForStep(entity_index, "legacyData")
          // children: [{
          //   path: getPathForStep(entity_index, 'employees', 'edit')
          // }]
        }
      ]},
  ];

  return navItems;
}

const getPathForStep = (entity_index, step_name, sub_step) => {
  if(sub_step=='modifyLegalEntity')
    return  `/onboarding/${step_name}/${entity_index}/${sub_step}`
  if (sub_step)
    return `/onboarding/entity/${entity_index}/${step_name}/${sub_step}`
  else
    return `/onboarding/entity/${entity_index}/${step_name}`
}

const getters = {
    legal_entity_ID: (state) => (index) => {
        if (state.data[index]) {
          //console.log('state.data',state.data)
            return state.data[index].id
        }
    },
    getLegalEntityList: (state) => {
        return state.data;
    },
    record: (state) => {
        return state.record
    },
    editMode: (state) => {
        return state.editMode
    }
}

const mutations = {
    set: (state, payload) => {
      //console.log("thisis payload", payload)  
      state.data = payload;
        
        // state.nav_items_entity = [];
        // for (let i = 0; i < state.data.length; i++) {
        //         state.nav_items_entity.push(state.nav_items(i));
        // }
    },

    setStepper: (state, payload) => {
        state.stepperStatus = setNavItemsState(payload.state, payload.entity_index);
    },

    addEntity: (state, payload) => {
        state.data.push(payload);
    },
    updateEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id === payload.id) {
                state.data[i] = payload;
            }
        }
    },
    removeEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i].id == payload) {
                state.data.splice(i, 1);
                state.nav_items_entity(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },

    setRecord: (state, payload) => {
        state.record = payload.record;
        state.editMode = payload.editMode;
    },

    setMode: (state, payload) => {
        state.editMode = payload;
    },

    setNavBarState: (state, payload) => {
      state.nav_items_entity[parseInt(payload.le_index)][payload.index].items[payload.sub_index].prev_status = state.nav_items_entity[parseInt(payload.le_index)][payload.index].items[payload.sub_index].status;
      state.nav_items_entity[parseInt(payload.le_index)][payload.index].items[payload.sub_index].status = payload.state;
    }
}

const updateToken = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
    async fetchAll({ commit }, orgid) {
        try {
            // to make call only when payload is available -291/11/2019
            updateToken();
            if (orgid) {
                commit("setFetching", true);
                let res = await axios_instance.get(`/`, { params: { org_id: orgid } })
                commit("setFetching", false);
                if (res.status == 200) {
                    if (res.data.status) {
                        commit("set", res.data.payload.data);
                    }
                }
                return res;
            }
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async fetchAllLegalEntities({ commit }, payload) {
      try {
          // to make call only when payload is available -291/11/2019
          updateToken();
          if (payload) {
              commit("setFetching", true);
              let res = await axios_instance.get(`/`, { params: { org_id: payload.org_id, email: payload.email, companyCode: payload.companyCode } })
              commit("setFetching", false);
              if (res.status == 200) {
                  if (res.data.status) {
                      commit("set", res.data.payload.data);
                  }
              }
              return res;
          }
      } catch (err) {
          throw errorHandler(err.response);
      }
  },
    async fetchStepperStatus({ commit }, payload) {
        try {
            // to make call only when payload is available -291/11/2019
            if (payload.le_id) {
                commit("setFetching", true);
                let res = await axios_instance_stepper_status.get(`/`, { params: { le_id: payload.le_id } })
                commit("setFetching", false);
                if (res.data.status) {
                    commit("setStepper", {state: res.data.payload.data[0], entity_index: payload.index});
                }
                return res;
            }
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEntity", res.data.payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.data.id}`, payload);
            commit("setSaving", false);
            if (res.data.status) {
                commit("updateEntityById", res.data.payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", payload);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },
    async changeMode({ commit }, payload) {
        try {
            commit("setRecord", payload)
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async changeEditMode({ commit }, payload) {
        try {
            commit("setMode", payload)
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    updateNavBarState({ commit }, payload) {
        try {
          if ( payload.prev_state == "pending" && payload.state != "active" ) {
            return;
          }

          if ( payload.prev_state == "active" && ( payload.state != "error" || payload.state != "complete")) {
            return;
          }

          if ( payload.prev_state == "error" && payload.state != "active" ) {
            return;
          }

          if ( payload.prev_state == "complete" && payload.state != "active" ) {
            return;
          }

          let index;
          let sub_index;
          switch (payload.code) {
            case 'legalEntity':
              index = 0;
              sub_index = 0;
              break;
            case 'location':
              index = 0;
              sub_index = 1;
              break;

            case 'statutory':
              index = 1;
              sub_index = 0;
              break;
            case 'costCentre':
              index = 1;
              sub_index = 1;
              break;
            case 'designation':
              index = 1;
              sub_index = 2;
              break;
            case 'level':
              index = 1;
              sub_index = 3;
              break;  
            case 'grade':
              index = 1;
              sub_index = 4;
              break;
            case 'category':
              index = 1;
              sub_index = 5;
              break;
            case 'band':
              index = 1;
              sub_index = 6;
              break;
            case 'misc':
              index = 1;
              sub_index = 7;
              break;
            case 'preferences':
              index = 1;
              sub_index = 8;
              break;
              case "fbpEligibility":
              index = 1;
              sub_index = 9;
            case 'paygroup':
              index = 1;
              sub_index = 10;
              break;
              case 'ctcSlab':
                index = 1;
                sub_index = 11;
                break;
              

            case 'employee':
                index = 2;
                sub_index = 0;
                break;
            default:
              index = 0;
              sub_index = 0;
          }

            payload.index = index;
            payload.sub_index = sub_index;
            commit("setNavBarState", payload);
        } catch (err) {
           //console.log("err :", err);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
